import "./EditableEntries.css";

const EditableEntryInput = ({reff, baseValue, editValue = baseValue, type, onEdit, isEditing, prefix = "", placeholder = "", requestSubmission = () => {}, nullValue = "Not Set", width}) => {
    return (
        isEditing ? (
            <>
                {prefix ? <span>{prefix}</span> : <></>}
                <input
                    ref={reff}
                    style={{width}}
                    type={type}
                    value={editValue === null ? '' : editValue}
                    placeholder={placeholder}
                    onChange={(e) => {
                        const dis = e.target;// as HTMLInputElement;

                        const validity = dis.validity;

                        /*if (required && validity.valueMissing) {
                            dis.classList.add(invalidClass);
                        } else if (!validity.valid) {
                            dis.classList.add(invalidClass);
                        } else {
                            dis.classList.remove(invalidClass);
                        }*/

                        if (type === "checkbox") {
                            onEdit(e.target.checked, validity);
                        } else {
                            onEdit(e.target.value, validity);
                        }
                    }}
                    onKeyDown={(e) => e.key === "Enter" ? requestSubmission() : false}
                />
            </>
        ) : (
            <>{baseValue ? (<span>{prefix}{baseValue}</span>) : <i>{nullValue}</i>}</>
        )
    );
}

export default EditableEntryInput;